var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"material-icons overflow",attrs:{"id":("overflow-trigger-" + _vm.itemId)},on:{"click":function($event){$event.stopPropagation();return _vm.show_options()}}},[_vm._v("more_horiz")])}
var staticRenderFns = []

export { render, staticRenderFns }